import { Button, Input, Table, Tag, Typography } from "antd";
import { IconEdit } from "Common/ReactIcons";
import { IconSearch } from "Common/ReactIcons";
import { connect } from "react-redux";
import "./Clinicians.scss";
import AutoCompleteDebounce from "Components/AutoCompleteDebounce";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import api from "utils/api";

const AllClinicians = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState(""); 
  const [searchOptions, setSearchOptions] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({
    speciality: null,
    status: null,
  });
  const [specialityOptions, setSpecialityOptions] = useState([]);
  const [issearchLoading, setIsSearchLoading] = useState(false);
  const history = useHistory();

  //
  const fetchData = async (params = {}) => {
    setLoading(true);
    const { searchValue, filters, pagination } = params;

    const query = new URLSearchParams({
      search: searchValue.key || "",
      speciality: filters.speciality || "",
      status: filters.status || "",
      page: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
    }).toString();

    try {
      const response = await api.get_doctor_detail_list(query);
      if (response.data.status === 200 && response.data.message === "success") {
        const { results, count } = response.data.data;
        const transResult = results.map((item, index) => ({
          ...item,
          key: index,
        }));
        setData(transResult);
        setPagination({ ...pagination, total: count });
      } else {
        console.error("Failed to fetch data: unexpected response format");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchSpecialityOptions = async () => {
    const query = new URLSearchParams({
      search : "speciality"
    })
    try {
      const response = await api.language_speciality_list(`${query}`); 
      if (response.data.status === 200 && response.data.message === "success") {
        const options = response.data?.data?.results.map((item) => ({
          text: item.field_value,
          value: item.id,
        }));
        setSpecialityOptions(options);
      } else {
        console.error("Failed to fetch speciality options: unexpected response format");
      }
    } catch (error) {
      console.error("Failed to fetch speciality options:", error);
    }
  };
  useEffect(()=>{
    fetchSpecialityOptions();
  },[])
  useEffect(() => {
    // fetchSpecialityOptions();
    fetchData({ searchValue, filters, pagination });
  }, [searchValue, filters, pagination.current, pagination.pageSize]);

  const handleTableChange = (Pagination, Filters) => {
    setPagination(Pagination);
    setFilters(Filters);
  };
  // useEffect(() => {
  //   setPagination((prev) => ({ ...prev, current: 1, pageSize: 10 }));
  //   fetchData({
  //     searchValue,
  //     filters,
  //     pagination: { current: 1, pageSize: 10 },
  //   });
  // }, [searchValue,filters]);
  const handleSearchChange = async (value) => {
    if (value) {
      setIsSearchLoading(true);
      try {
        const query = new URLSearchParams({ search: value }).toString();
        const response = await api.get_doctor_name_search(query);

        if (
          response.data.status === 200 &&
          response.data.message === "success"
        ) {
          const { results } = response.data.data;
          const options = [];

          results.forEach((result) => {
            if (result.name) {
              result.name.forEach((item) => {
                options.push({
                  value: item.doctor_name,
                  label: `${item.doctor_name} - ${item.specialization}`,
                  key: item.doctor_id,
                });
              });
            }

            if (result.email) {
              result.email.forEach((item) => {
                options.push({
                  value: item.email,
                  label: `${item.email} - ${item.doctor_name}`,
                  key: item.doctor_id,
                });
              });
            }
            if (result.mobile_number) {
              result.mobile_number.forEach((item) => {
                options.push({
                  value: item.mobile_number,
                  label: `${item.doctor_name}-${item.mobile_number}`,
                  key: item.doctor_id,
                });
              });
            }
          });

          setSearchOptions(options);
        } else {
          console.error("Failed to fetch data: unexpected response format");
        }
      } catch (error) {
        console.error("Failed to fetch search options:", error);
      } finally {
        setIsSearchLoading(false);
      }
    } else {
      setSearchValue("");
      setSearchOptions([]);
    }
  };
  const getStatusTag = (status) => {
    let color = "";
    switch (status) {
      case "Active":
        color = "#4AB915";
        break;
      case "Disabled":
        color = "#A60000";
        break;
      default:
        color = "#4AB915";
        break;
    }
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          color: color,
          gap: "8px",
        }}
      >
        <div
          style={{
            backgroundColor: color,
            width: "8px",
            height: "8px",
            borderRadius: "50%",
          }}
        ></div>
        <div>{status}</div>
      </div>
    );
  };
  const columns = [
    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
      width: 150,
    },
    {
      title: "CONTACT/EMAIL",
      key: "email",
      // width: 150,
      render: (text, record) => (
        <div>
          <div>{`${record.country_code}${record.mobile_number}`}</div>
          <div>{record.email}</div>
        </div>
      ),
    },
    {
      title: "QUALIFICATION",
      dataIndex: "qualification",
      key: "qualification",
      width: 120,
      render: (text, record) => (
        <Typography.Text
          style={{ width: 200 }}
          ellipsis={{ rows: 2, tooltip: { title: text, placement: "top" } }}
        >
          {text}
        </Typography.Text>
      ),
    },
    {
      title: "SPECIALITY",
      dataIndex: "speciality",
      key: "speciality",
      width: 120,
      render: (text, record) => (
        <Typography.Text
          style={{ width: 200 }}
          ellipsis={{ rows: 2, tooltip: { title: text, placement: "top" } }}
        >
          {text}
        </Typography.Text>
      ),
      filters: specialityOptions,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      width: 100,
      filters:[
        {text:"Active",value:"Active"},
        {text:"Disabled",value:"Disabled"},
      ],
      render: (text, record) => getStatusTag(record.status),
    },
    {
      title: " ",
      key: "action",
      align: "right",
      width: 150,
      render: (text, record) => (
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}
        >
          <Button
            type="link"
            icon={<IconEdit />}
            onClick={() => {
              history.push(`${props.user_details.baseUrl}/edit-clinician`, {
                doctor_id: record.doctor_id,
              });
            }}
          />
          
          <Button
            type="link"
            // icon={<IconEdit />}
            onClick={() => {
              history.push(`${props.user_details.baseUrl}/clinician-check-availability`, {
                doctor_id: record.doctor_id,...record,
              });
            }}
          ><span>Check Availability</span></Button>
        </div>
      ),
    },
  ];
  return (
    <div className="clinician-table">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <AutoCompleteDebounce
          options={searchOptions}
          style={{ padding: "0px 24px 0px 16px" }}
          onSelect={(value, option) => setSearchValue(option)}
          onSearch={handleSearchChange}
          loading={issearchLoading}
        >
          <Input
            prefix={<IconSearch />}
            style={{ height: "100%", width: "412px" }}
            placeholder="Search the doctor by Name/Contact No./Email."
          />
        </AutoCompleteDebounce>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        onChange={handleTableChange}
        rowKey="key"
        pagination={pagination}
        scroll={{ x: "max-content" }}
        // className="clinician-table"
        // tableLayout="fixed"
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(AllClinicians);
